module.exports = __webpack_public_path__ + "img/mobile-apps.887b0a83.svg";